import { useState, useEffect } from 'react'
import { t } from '@lingui/core/macro'
import DropdownTreeSelect, { ShowDropdownState } from 'react-dropdown-tree-select'
import { useDeepCompareEffect } from 'react-use'
import 'react-dropdown-tree-select/dist/styles.css'
import { Theme } from 'Theme'
import { styles } from './styles'

interface Props {
  row: number
  data: any[]
  multi: boolean
  updateData: (selected: any[]) => void
  showDropdown?: ShowDropdownState
}

export const SelectTreeDropdown = ({
  row,
  data,
  multi,
  updateData,
  showDropdown = undefined, // default to undefined so we can show the undefined variation in storybook.
}: Props) => {
  const [state, setState] = useState({
    selected: null,
    row,
    data: JSON.parse(JSON.stringify(data)),
  })

  useEffect(() => {
    const [menu] = document.querySelectorAll('.dropdown-content')

    if (!menu) {
      return
    }

    menu.addEventListener('wheel', (e: Event) => {
      const wheelEvent = e as WheelEvent
      menu.scrollTop += wheelEvent.deltaY
    })
  }, [])

  // Set data if data changes from parent container.
  useDeepCompareEffect(() => {
    if (!data?.length) return

    setState(prevState => ({ ...prevState, data: JSON.parse(JSON.stringify(data)) }))
  }, [data])

  function handleClick(_newNode, selectedItems) {
    updateData(selectedItems)
  }

  return (
    <Theme>
      <DropdownTreeSelect
        className=""
        css={styles}
        data={state.data}
        onChange={handleClick}
        showDropdown={showDropdown}
        keepChildrenOnSearch={true}
        keepTreeOnSearch={true}
        texts={{ placeholder: t`Search` }}
        mode={multi ? 'multiSelect' : 'radioSelect'}
        keepOpenOnSelect={true}
      />
    </Theme>
  )
}
